import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { WaitState } from "@redotech/redo-return-ui/flows/return-flow/wait";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const WaitDetails = memo(function WaitDetails({
  state,
  stepSelect,
  setState,
}: StepTypeDetailsProps<WaitState>) {
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );

  const nextStepChange = useHandler((next: StepId | undefined) => {
    setState((state) => ({ ...state, next }));
  });
  const [numDays, setNumDays] = useState<string>("1");

  const inputChange = (value: string) => {
    setNumDays(value);
    setState((state) => ({ ...state, numDays: parseInt(value) }));
  };

  return (
    <>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Delay (days)
        </Text>
        <RedoTextInput
          min={1}
          placeholder="Enter number of days..."
          setValue={inputChange}
          state={canEditReturnsSettings ? "default" : "readonly"}
          value={numDays}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Next step
        </Text>
        {stepSelect({ value: state.next, valueChange: nextStepChange })}
        {!state.next && (
          <Text fontSize="xs" textColor="error">
            Required
          </Text>
        )}
      </Flex>
    </>
  );
});
